import { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getStoredTrackingParams, normalizeVariation } from "src/analytics/urlParams";

/**
 * Keeps the `variation` query-param in the URL across all route changes.
 * Reads the stored variation from sessionStorage (captured on first landing)
 * and re-appends it if it's missing from the current URL.
 */
export function usePreserveVariation(): void {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const stored = normalizeVariation(getStoredTrackingParams()?.variation);
    if (!stored) return;

    const current = normalizeVariation(searchParams.get("variation"));
    if (current !== stored) {
      const next = new URLSearchParams(searchParams);
      next.set("variation", stored);
      navigate(
        { pathname: location.pathname, search: next.toString() },
        { replace: true, state: location.state },
      );
    }
  }, [location.pathname, location.state, navigate, searchParams]);
}
